module.exports = __webpack_public_path__ + "static/media/logo_spenmo.25d69c22.svg";